import css from 'styled-jsx/css';
import { colors } from 'components/styles/variables';
import { makeStyles, Theme } from '@material-ui/core/styles';

export const useDropdownButtonStyles = makeStyles<Theme>(() => ({
  root: {
    margin: 0,
    padding: 0,
    textTransform: 'none',
    boxSizing: 'unset',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}));

export const usePopperStyles = makeStyles<Theme>(() => ({
  root: {
    zIndex: 600,
    background: 'white',
    minWidth: '296px',
    borderRadius: '8px',
    border: `1px solid ${colors.G2}`,
    filter: 'drop-shadow(0px 24px 38px rgba(0, 0, 0, 0.2))',
    top: '36px',
  },
}));

const styles = css`
  .dropdown-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: ${colors.WHITE};
    height: 44px;
    border-radius: 4px;
    margin: 0 16px 16px 16px;
    border: 1px solid ${colors.G2};
  }
  .dropdown-container:hover,
  .black-border {
    border-color: ${colors.BLACK};
  }
  .dropdownDisabled:hover {
    border-color: ${colors.G2};
  }
  .menu-item {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    cursor: pointer;
    width: 100%;
  }
`;
export default styles;
